<template>
  <PageTabs
    v-model:tabKey="activeKey"
    tabName="brand"
    :title="$t('pin-pai-gui-fan')"
  >
    <template #pageExtra>
      <FollowLock
        v-if="
          checkPermission(ActionListKey.BRAND_FOLLOW) &&
          hasActionPermission('brand_manage_follow')
        "
        :user-name="info?.to_user_name"
        :org-name="
          status === FOLLOW_STATUS.FOLLOWING
            ? info?.accept_org_name
            : info?.to_org_name
        "
        :from-org-name="info?.from_org_name"
        :status="status"
        @success="getInfo"
      />
    </template>

    <template v-for="x in tabs" #[x.key] :key="x.key">
      <component
        :is="BrandPage['' + x.key]"
        :ref="(el: any) => (pageRef[x.key] = el)"
        :status="status"
        :editData="editData"
        :hasUpload="hasUpload"
        :menuFilter="menuFilter"
      />
    </template>
    <!-- <PgcPerson v-if="activeKey === RESOURCE_TYPE.PERSON" /> -->
  </PageTabs>
</template>
<script lang="ts" setup>
import Page from './components/page'
import FollowLock from './components/followLock/index.vue'
// import PgcPerson from './components/pgcPerson.vue'
import { getFollowing, updateBrand } from '~/api'
import { USER_LEVEL_KEY, type Following, FOLLOW_STATUS } from '~/api/interface'
import { USER_ADMIN } from '~/constants'

const BrandPage = Page as Record<string, any>
const tabs = useDicts('brand')
const route = useRoute()
const activeKey = ref(
  route.query?.key ? Number(route.query.key) : (tabs[0].key as number)
)

const pageRef = ref<any>({})

const userInfo = useUserInfo()
const { hasActionPermission } = usePageAndActionPermissionData()

const info = ref<Following>()

const status = computed(() => {
  const { rights_type = USER_LEVEL_KEY.TASTE, permission } =
    userInfo.value || {}
  if (
    [
      USER_LEVEL_KEY.TASTE,
      USER_LEVEL_KEY.PERSONAL,
      USER_LEVEL_KEY.PERSONAL_LITE,
    ].includes(rights_type) ||
    permission === USER_ADMIN.NORMAL
  ) {
    return FOLLOW_STATUS.NONE
  }

  if (!info.value) {
    return FOLLOW_STATUS.FOLLOW
  }

  return info.value.status
})
const tabItem = computed(() => {
  return useDictItem('brand', activeKey.value)
})

const hasUpload = computed(() => {
  return !(
    status.value === FOLLOW_STATUS.FOLLOWED ||
    !checkPermission(ActionListKey.BRAND_UPLOAD)
  )
})

const editData = computed(() => {
  if (
    status.value === FOLLOW_STATUS.FOLLOWED ||
    status.value === FOLLOW_STATUS.FOLLOWING ||
    !checkPermission(ActionListKey.BRAND_RENAME)
  ) {
    return undefined
  }

  return {
    name: (record: Record<string, any>, value: string, source: any) => {
      if (tabItem.value) {
        trackEvent(TRACK_EVENT.RENAME_TARGET, {
          target: tabItem.value.target,
          source: SOURCE.BRAND,
          click: source,
        })
      }
      return updateBrand({
        id: record.id,
        name: value,
      })
    },
  }
})

const menuFilter = (key: string, record: any) => {
  if (
    [ActionListKey.BRAND_RENAME, ActionListKey.BRAND_GUIDELINES].includes(
      key as any
    ) &&
    status.value === FOLLOW_STATUS.FOLLOWED
  ) {
    return false
  }

  if (key === ActionListKey.BRAND_PLAY) {
    return !!record.preview_video_list && record.preview_video_list.length > 0
  }

  return true
}

const getInfo = async () => {
  const res = await getFollowing()
  if (res.code !== 0) {
    return
  }

  info.value = res.data?.[0]
}

let timer: any

const initTimer = () => {
  if (timer) {
    clearInterval(timer)
  }

  timer = setInterval(getInfo, 1000 * 10)
}

watch(
  status,
  (v) => {
    if (v === FOLLOW_STATUS.FOLLOWING) {
      initTimer()
    } else {
      clearInterval(timer)
    }
  },
  { immediate: true }
)

watch(
  activeKey,
  (v) => {
    pageRef.value?.[v]?.onTabChange?.()
    pageRef.value?.[v]?.reload?.()
    const item = useDictItem('brand', v)
    if (item) {
      trackEvent(TRACK_EVENT.PAGE_BRAND, {
        target: item.target,
      })
    }
  },
  { immediate: true }
)

watch(
  () => route.params?.key,
  (cur) => {
    if (cur) {
      activeKey.value = Number(cur)
    }
    // pageRef.value?.[activeKey.value]?.reload?.()
  }
  // { immediate: true }
)

provideResourceLocation({
  source: SOURCE.BRAND,
})

onBeforeUnmount(() => {
  clearInterval(timer)
})

onMounted(() => {
  getInfo()
})
</script>

<style lang="scss" scoped></style>
